import Box from "@mui/material/Box/Box";
import {Typography} from "@mui/material";
import React from "react";

export const TabPanel =(props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box sx={{ p: 3 }} className={value === index ? '' : 'hidden'}>
                <Typography>{children}</Typography>
            </Box>
        </div>
    );
}

export const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}